(function ($) {
  $(document).ready(function () {


    const currentPage = location.href;

    $('.menu-principal li a').each(function () {
      var $this = $(this);
      // console.log($this.attr('href'))
      // if the current path is like this link, make it active
      if ($this.attr('href') && $this.attr('href') == currentPage) {
        $this.addClass('active');
      }
    })

    if (currentPage.includes('/type-produits') || currentPage.includes('/produits')) {

      $('.menu-principal li:first-child a').addClass('active')
    } else if (currentPage.includes('/installateurs')) {
      $('.menu-principal li:nth-child(2) a').addClass('active')
    } else if (currentPage.includes('/conseils')) {
      $('.menu-principal li:nth-child(5) a').addClass('active')
    }





    /**
     * 
     * SCROLL TO THE TOP CODE WITH THE ARROW ON THE
     * RIGHT SIDE OF THE PAGE
     * 
     */
    const maxHeight = document.body.scrollHeight;
    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        $('.header-desktop__fixed').addClass('active')
      } else {
        $('.header-desktop__fixed').removeClass('active')
      }
      // if ($(window).scrollTop() > maxHeight * 0.8) {
      //   $('.questions-content').addClass('inactive')
      //   $('.back-to-top').addClass('active')
      // } else {
      //   $('.questions-content').removeClass('inactive')
      //   $('.back-to-top').removeClass('active')
      // }
    });
    $('.back-to-top').on('click', function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    })

    /**
     * 
     * MANAGE ALL THE SLICK CAROUSEL HERE
     * 
     */

    let autoplayInterval;

    // Initialize Slick carousel
    if ($('.section-hero__home-slick_initialized').length > 0) {
      const $carousel = $('.section-hero__home-slick_initialized').slick({
        prevArrow: $('.hero-slick__prev'),
        nextArrow: $('.hero-slick__next'),
        adaptiveHeight: true,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              prevArrow: false,
              nextArrow: false,
            }
          }
        ]
      });

      // Listen for slide changes
      $carousel.on('afterChange', handleSlideChange);

      // Trigger the initial slide check
      handleSlideChange(null, $carousel.slick('getSlick'), $carousel.slick('slickCurrentSlide'));

      function handleSlideChange(event, slick, currentSlide) {
        const $currentSlide = $(slick.$slides[currentSlide]);

        // Clear any existing autoplay interval
        clearInterval(autoplayInterval);

        // Check if the current slide contains a video
        const video = $currentSlide.find('video');
        if (video.length > 0) {
          // Pause Slick autoplay
          $carousel.slick('slickPause');

          // Play the video
          const videoElement = video.get(0);
          videoElement.play();

          // Wait for the video to finish
          video.off('ended').on('ended', function () {
            $carousel.slick('slickNext'); // Move to the next slide
            $carousel.slick('slickPlay'); // Resume autoplay
          });
        } else {
          // For image slides, set up autoplay with a 5-second interval
          autoplayInterval = setInterval(() => {
            $carousel.slick('slickNext');
          }, 5000);
        }
      }
    }

    // $('.section-posttype__slick').slick({
    //   slidesToShow: 4,
    //   dots: false,
    //   arrows: false,
    //   responsive: [
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //       }
    //     },
    //     {
    //       breakpoint: 576,
    //       settings: {
    //         slidesToShow: 1.1,
    //         slidesToScroll: 1,
    //         infinite: false,
    //         dots: false,
    //         centerMode: true,
    //         centerPadding: '30px',
    //       }
    //     },
    //   ]
    // })
    $('.section-notices__slick').slick({
      slidesToShow: 3,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false

          }
        },
      ]
    })
    $('.form-slides').slick({
      dots: false,
      arrows: false,
      adaptiveHeight: true,
      swipe: false,
      swipeToSlide: false,
      infinite: false
    })

    $('.wpcf7-submit').on('click', function () {
      $('.loader-estimate').addClass('active')
    })

    document.addEventListener('wpcf7mailsent', function (event) {
      $('.form-slides').slick('slickNext');
      $('.loader-estimate').removeClass('active')

    }, false);

    document.addEventListener('wpcf7invalid', function (event) {
      $('.loader-estimate').removeClass('active');
    }, false);

    document.addEventListener('wpcf7mailfailed', function (event) {
      $('.loader-estimate').removeClass('active');
    }, false);



    $('.galery-installateur__slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav-thumbnails'
    });
    $('.slider-nav-thumbnails').slick({
      slidesToShow: 3,
      slidesToScroll: 0,
      dots: false,
      asNavFor: '.galery-installateur__slick',
      centerMode: true,
      focusOnSelect: true,
      arrows: false
    });
    $('.sections-inspirations__slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav-thumbnails__inspirations'
    });
    $('.slider-nav-thumbnails__inspirations').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      asNavFor: '.sections-inspirations__slick',
      centerMode: true,
      focusOnSelect: true,
      infinite: false
    });

    $('.galery-works__mobile').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.galery-works__thumbnails'
    });
    $('.galery-works__thumbnails').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      asNavFor: '.galery-works__mobile',
      centerMode: true,
      focusOnSelect: true
    });


    $(".hero-installateur__anim").click(function (e) {
      e.preventDefault();
      var aid = $(this).attr("href");
      $('html,body').animate({ scrollTop: $(aid).offset().top }, 'slow');
    });



    $('.btn-prev__slide').on('click', function () {
      $('.form-slides').slick('slickPrev');
    })
    $('.btn-next__slide').on('click', function () {
      // console.log($(this).attr('data-selected'))
      if ($(this).attr('data-selected') == "true") {
        $('.error-messages').removeClass('active')
        $('.form-slides').slick('slickNext');
        $('html, body').animate({
          scrollTop: $('.form-slider').offset().top - 100
        }, 'slow');
        var valuesString = checkboxChecked.join(',');
        var valuesString = valuesString.replace(/_/g, ' ');
        $('#checkbox_values').val(valuesString);
      } else {
        $('.error-messages').addClass('active')
        $('.form-slides').slick('resize');
        $('.form-slides').slick('setDimensions');
        $('.form-slides').slick('setPosition');


      }

    })
    $('form.wpcf7-form').on('keyup change', 'input, textarea, select', function () {
      checkValidationTips();
    });

    function checkValidationTips() {
      if ($('.wpcf7-not-valid-tip:visible').length > 0) {
        $('.form-slides').slick('resize');
        $('.form-slides').slick('setDimensions');
        $('.form-slides').slick('setPosition');
      }
    }

    const checkboxChecked = []
    if ($('input').length > 0) {
      let currentSlide = $('.slick-active')

      if (currentSlide.find('input[name="typedemande"]').length > 0) {
        $('#btn-next__slide').attr('data-selected', true);
      }

      $('input[name="products[]').on('click', function () {
        currentSlide = $('.slick-active')
        const value = this.value;
        const isChecked = this.checked;
        if (isChecked) {
          // Add the value to the array if the checkbox is checked
          checkboxChecked.push(value);
        } else {
          // Remove the value from the array if the checkbox is unchecked
          const index = checkboxChecked.indexOf(value);
          if (index !== -1) {
            checkboxChecked.splice(index, 1);
          }
        }
        const atLeastOneChecked = checkboxChecked.length > 0
        console.log(atLeastOneChecked)
        currentSlide.find('.btn-next__slide').attr('data-selected', atLeastOneChecked);
      })



    }


    const urlParams = new URLSearchParams(window.location.search);
    const checkValue = urlParams.get('check');
    console.log(checkValue)

    setTimeout(() => {
      if (checkValue) {
        $('#type_demande').val(checkValue);

      }
    }, 1000);

    $('input[name="typedemande"]').on('click', function () {
      $('#type_demande').val($(this).val())
      console.log($(this).val())
    })
    $('.popup-install').on("click", ".selected-install", function (e) {
      let idInstalleur = $(this).attr('data-id')
      $('input[name="installateurs"]').val(idInstalleur)
      console.log($('input[name="installateurs"]'))
      $('.form-slides').slick('slickNext');
      $('.seize-popup').removeClass('active')
    })


    $('.no-installateur').on("click", function (e) {
      let idInstalleur = 0

      $('input[name="installateurs"]').val(idInstalleur)
      $('.form-slides').slick('slickNext');
      // $('.seize-popup').removeClass('active')
    })


    /**
     * 
     * Manage the menu hover with the submenu-secondary or submenu-tertiary
     * 
     */

    $('.menu-principal__link-primary').on('mouseover', function () {
      const hasDataSub = $(this).attr("data-sub") !== undefined;
      $('.row-submenu').removeClass('active')
      $('.container-test').removeClass('active')
      if (hasDataSub) {
        let dataSub = $(this).attr("data-sub")
        $('.row-submenu[data-submenu="' + dataSub + '"]').addClass('active')
        $('.container-test').addClass('active')
        $('.container-test').height($('.row-submenu[data-submenu="' + dataSub + '"]').outerHeight(true));


      }
    })

    $('.menu-principal__secondary-link').on('mouseover', function () {
      const hasDataSub = $(this).attr("data-submenusecondary") !== undefined;
      $('.menu-principal__three').removeClass('active')
      $('.sub-menu__inner-img img').removeClass('active')
      if (hasDataSub) {
        let dataSub = $(this).attr("data-submenusecondary")
        $('.sub-menu__inner-img img[data-img="' + dataSub + '"').addClass('active')

        $('.menu-principal__three[data-submenutertiary="' + dataSub + '"]').addClass('active')
      }
    })

    /**
     * 
     * Manage the mobile menu (hamburger, show, hide...)
     * 
     */


    $('button.hamburger').on('click', function () {
      if ($(this).hasClass('active')) {
        $('.header-mobile__menu-sub').removeClass('active')
      }
      $(this).toggleClass('active')
      $('.header-mobile__menu').toggleClass('active')
    })

    $('.header-mobile__list.header-mobile__sub').on('click', function (e) {
      e.preventDefault();
      $(this).addClass('active')
    })

    $('.menu-mobile__tertiary-list a').on('click', function () {
      window.location.href = $(this)[0].href
    })
    $('.header-mobile__secondary-list.header-mobile__secondary-sub .has-menu').on('click', function (e) {


      // $('.header-mobile__secondary-sub svg').removeClass('active')
      // $('.menu-principal__three').removeClass('active')


      $(this).parents('.header-mobile__secondary-sub').find('svg').toggleClass('active')
      $(this).parents('.header-mobile__secondary-sub').find('.menu-principal__three').toggleClass('active')
      // $('.menu-principal__three').removeClass('active')
      // e.preventDefault();
      // const hasDataSub = $(this).attr("data-submenusecondary") !== undefined;
      // if (hasDataSub) {
      //   let dataSub = $(this).attr("data-submenusecondary")

      //   $('.menu-principal__three[data-submenutertiary="' + dataSub + '"]').addClass('active')
      // }

      // $('.header-mobile__menu-sub').addClass('active')

    })

    $('.menu-principal__three-back').on('click', function () {
      $('.header-mobile__menu-sub').removeClass('active')
    })



    $('.hero-installateur .btn-phone').on('click', function (e) {

      if ($(this).attr('href') == undefined) {
        e.preventDefault
        let tel = $(this).children('span').attr('data-tel')
        let formated_tel = ""

        for (var i = 0; i < tel.length; i += 2) {
          if (i > 0) {
            formated_tel += "."; // Add a comma, except for the first iteration
          }
          formated_tel += tel.slice(i, i + 2); // Add the next two characters
        }

        $(this).children('span').text(formated_tel)

        $(this).attr("href", "tel:" + tel)
        e.preventDefault()
      }
    })


    /**
     * 
     * NOT FINISHED BECAUSE CLIENT DOESN'T KNOW WHAT HE REALLY WANTS
     * Code to append questions and answers in the pop-up questions-list
     * Ajax Request to the get_responses_options
     * Params : question_id : id of the question clicked to compare the acf repeater
     * Questions managed on the options page
     * 
     */

    $('.questions-list__inner-questions').on('click', function () {
      let id = $(this).attr('id')
      let inner_questions = $('.questions-list__inner-all').clone(true)
      let response_inner = $('.questions-list__inner-response').clone(true)

      $(this).addClass('active')

      $.ajax({
        url: seize_data.ajaxUrl, // This variable is defined by WordPress and points to admin-ajax.php
        type: 'POST',
        data: {
          action: 'get_responses_options',
          question_id: id,
        },
        dataType: 'json',
        success: function (response) {

          response_inner.children('span').text(response)
          $('.questions-list__inner').append(response_inner)
          $('.questions-list__inner').append(inner_questions)
        }
      })
    })


    /**
     * 
     * Code working with the acf-block w-hero-truck to show after 1 sec an image
     * 
     */
    setTimeout(() => {
      $('.section-hero__truck-foreground').addClass('active')
    }, 1000);





    const selectBox = $(".select-box");
    const stateSelect = $(".select-state");
    const stateOptionsList = stateSelect.find(".options");
    const stateCheckboxes = stateSelect.find('input[type="checkbox"]');
    const statePlaceholder = stateSelect.find(".select-box__placeholder");


    const citySelect = $(".select-city");
    const cityOptionsList = citySelect.find(".options");
    const cityCheckboxes = citySelect.find('input[type="checkbox"]');
    const cityPlaceholder = citySelect.find(".select-box__placeholder");

    stateSelect.on("click", function (event) {
      stateOptionsList.toggleClass("show");
      event.stopPropagation(); // Prevent event propagation
    });


    $(document).on("click", ".installateur-list__single .open-pop", function () {
      let id = $(this).attr('data-id')
      // console.log(id)

      $.ajax({
        url: seize_data.ajaxUrl, // This variable is defined by WordPress and points to admin-ajax.php
        type: 'POST',
        data: {
          action: 'get_installateur_form',
          id: id,
        },
        dataType: 'json',
        success: function (response) {
          // console.log(response)
          $('.popup-install').html(response)
          $('.seize-popup').addClass('active')
        }
      })
    })
    $(document).on('click', '.installateur-inner__response .close', function () {
      $('.seize-popup').removeClass('active')
    })


    stateCheckboxes.on("change", function (event) {
      // $('.select-state .options input[type="checkbox"]').prop('checked', false)
      // console.log($(this).prop('checked'))
      // if ($(this).prop('checked', true)) {
      //   $(this).prop('checked', false)
      // } else {
      //   $(this).prop('checked', true)
      // }

      let value = $(this).val()
      $('input[type="checkbox"][value="' + value + '"]').each(function () {
        $(this).toggleClass('active')
      })

      // event.stopPropagation;
      updateStatePlaceholder();
    });

    citySelect.on("change", 'input', function (event) {
      event.stopPropagation;
      updateCityPlaceholder();
    });

    stateOptionsList.on("mouseleave", function () {
      stateOptionsList.removeClass("show");
    });

    cityOptionsList.on("mouseleave", function () {
      cityOptionsList.removeClass("show");
    });

    function updateStatePlaceholder() {
      const checkedItems = stateCheckboxes
        .filter(":checked")
        .map(function () {
          return $(this).parent().text();
        })
        .get();

      if (checkedItems.length > 0) {
        statePlaceholder.text(checkedItems)
      } else {
        statePlaceholder.text("Sélectionner votre région");
      }
    }
    function updateCityPlaceholder() {
      const cityCheckboxes = citySelect.find('input[type="checkbox"]');

      const checkedItems = cityCheckboxes
        .filter(":checked")
        .map(function () {

          return $(this).parent().text();
        })
        .get();

      if (checkedItems.length > 0) {
        cityPlaceholder.text(checkedItems.join(", "));

      } else {
        cityPlaceholder.text("Sélectionner votre région");
      }
    }

    $('.map-installateur__paragraph-button').on('click', function () {
      $('.map-installateur__paragraph-span').toggleClass("active");
      if ($('.map-installateur__paragraph-span').hasClass('active')) {
        $(this).text('Voir moins')
      } else {
        $(this).text('Voir plus')

      }
    })

    $(document).keypress(
      function (event) {
        if (event.which == '13') {

          event.preventDefault();
        }
      });

    stateCheckboxes.on('change', function () {
      $('.select-city').addClass('inactive')
      checkboxCities = $('.select-city .options')
      checkboxCities.empty()
      var checkedStates = []
      checkedStates = $(this).val()
      $installateur_list = $('.installateur-list')
      $installateur_list.addClass('inactive')
      if (checkedStates.length > 0) {
        $('#select-city__input').val('')
        $.ajax({
          url: seize_data.ajaxUrl, // This variable is defined by WordPress and points to admin-ajax.php
          type: 'POST',
          data: {
            action: 'get_custom_taxonomy_posts',
            taxonomy: 'regions',
            value: checkedStates,
          },
          dataType: 'json',
          success: function (response) {
            $installateur_list.empty()
            if ($('.form-slides__map').length > 0) {
              $.each(response, function (index, single) {
                $installateur_list.append('<div class="installateur-list__single"><a class="open-pop" data-id="' + single.id + '"><h2>' + single.name + '</h2><hr><p class="installateur-list__single-city">' + single.term + '</p></a></div>')
              })
            } else {

              $.each(response, function (index, single) {
                $installateur_list.append('<div class="installateur-list__single"><a href="' + single.permalink + '"><h2>' + single.name + '</h2><hr><p class="installateur-list__single-city">' + single.term + '</p></a></div>')
              })
            }
            $('.select-city').removeClass('inactive')
            $installateur_list.removeClass('inactive')
            // $.each(response, function (index, city) {


            //   setTimeout(() => {
            //     let cityCheckboxes = citySelect.find('input[type="checkbox"]');

            //   }, 2000);
            //   checkboxCities.append('<label for="' + city.slug + '"><input id="' + city.slug + '" type="checkbox" value="' + city.slug + '">' + city.name + '<span class="checkmark"></span></label>')

            // });

          }
        })
      }
    })

    // $('#select-city__input').on('input', function () {
    //   var inputValue = $(this).val();
    //   if (inputValue.length > 4) {
    //     $.ajax({
    //       type: 'POST',
    //       url: seize_data.ajaxUrl,
    //       data: {
    //         action: 'get_city_input',
    //         value: inputValue
    //       },
    //       success: function (response) {
    //         // Handle the AJAX response
    //         $('#result').html(response);
    //         $('#result').addClass('active')
    //         $('.ville-input').on('click', (event) => {
    //           console.log($(event.currentTarget))
    //           // On récupère la valeur de la ville cliquée
    //           // Faire la requete ajax
    //         })
    //       }
    //     });
    //   }
    // })


    function test() {
      console.log($(this))
      console.log(element)
    }









    // $('.questions-content__btn').on('click', function () {

    //   $('.questions-list').toggleClass('active')
    // })

    // $('.questions-list__header .close').on('click', function () {
    //   $('.questions-list').toggleClass('active')

    // })

    $('#map-installateur__submit').on('click', function () {
      var checkedStates = []
      var checkedCities = []
      $installateur_list = $('.installateur-list')
      $installateur_list.addClass('inactive')


      stateCheckboxes.filter(":checked")
        .map(function () {
          checkedStates = $(this).val()
        })
      const citySelect = $(".select-city");
      const cityOptionsList = citySelect.find(".options");
      const cityCheckboxes = citySelect.find('input[type="checkbox"]');

      // cityCheckboxes.filter(":checked")
      //   .map(function () {
      //     checkedCities = $(this).val())
      //   })

      $.ajax({
        url: seize_data.ajaxUrl, // This variable is defined by WordPress and points to admin-ajax.php
        type: 'POST',
        data: {
          action: 'get_install_filters',
          state_slug: checkedStates,
          cities_slug: checkedCities,
        },
        dataType: 'json',
        success: function (response) {
          $installateur_list.empty()
          $.each(response, function (index, single) {
            if ($('.form-slides__map').length > 0) {
              $.each(response, function (index, single) {
                $installateur_list.append('<div class="installateur-list__single"><a class="open-pop" data-id="' + single.id + '"><h2>' + single.name + '</h2><hr><p class="installateur-list__single-city">' + single.term + '</p></a></div>')
              })
            } else {
              $installateur_list.append('<div class="installateur-list__single"><a href="' + single.permalink + '"><h2>' + single.name + '</h2><hr><p class="installateur-list__single-city">' + single.term + '</p></a></div>')
            }
          })
          $installateur_list.removeClass('inactive')


        }
      })

    })


    $('.realisations-content__row-filters li').on('click', function () {
      $('.realisations-content__row-filters li').removeClass('active')
      $(this).addClass('active')
      var selectedFilter = $(this).data('filter');

      $('.realisations-content__row-col').each(function () {
        var filters = $(this).data('img');
        if (filters.includes(selectedFilter)) {
          $(this).show();
          $(this).addClass('gallery-image__active')
        } else {
          $(this).hide();
          $(this).removeClass('gallery-image__active')
        }
      });
    })

    $('.filterlist-li').on('click', function () {
      $('.filterlist-li').removeClass('active')
      $(this).addClass('active')
      var selectedFilter = $(this).data('filter');

      $('.product-colors__listing-single').each(function () {
        var filters = $(this).data('filter');
        if (filters.includes(selectedFilter)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });

    $('.documentation .filters-category li').on('click', function () {
      $('.filters-category li').removeClass('active')
      $('.filters-category li').addClass('inactive')
      $(this).addClass('active')
      var cat = $(this).data('filters')
      $('.docs-content__secondary-col').css('display', 'none')
      $('.docs-content__secondary-col[data-filter*="' + cat + '"]').css('display', 'flex')


    })

    $('.filters-category li').on('click', function () {
      $('.filters-category li').removeClass('active')
      $('.filters-category li').addClass('inactive')
      $(this).addClass('active')
      var cat = $(this).data('filters')
      $.ajax({
        url: seize_data.ajaxUrl, // This variable is defined by WordPress and points to admin-ajax.php
        type: 'POST',
        data: {
          action: 'get_conseils_by_category',
          cat_slug: cat,
        },
        success: function (response) {
          $('.conseils-content__secondary-row').empty()
          $('.conseils-content__secondary-row').append(response)
          $('.filters-category li').removeClass('inactive')
        }
      })
    })

    let images = [];
    let currentIndex = 0;

    $('.gallery-image').click(function () {
      images = [];
      const imageUrl = $(this).data('thumb');
      $('.realisations-lightbox__image').attr('src', imageUrl);

      $('.gallery-image__active').each(function (index) {
        $(this).children('img')
        images.push($(this).children('img').data('thumb'));
      })


      $('#realisations-lightbox').fadeIn();
    });
    $('.close').click(function () {
      $('#realisations-lightbox').fadeOut();
    });
    $(document).click(function (event) {
      if ($(event.target).is('#realisations-lightbox')) {
        $('#realisations-lightbox').fadeOut();
      }
    });

    $('.realisations-lightbox__content-prev').on('click', function () {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      $('.realisations-lightbox__image').attr('src', images[currentIndex]);
    })
    $('.realisations-lightbox__content-next').on('click', function () {
      currentIndex = (currentIndex + 1 + images.length) % images.length;
      $('.realisations-lightbox__image').attr('src', images[currentIndex]);
    })

    $(document).keydown(function (e) {
      if ($('#realisations-lightbox').is(':visible')) {
        if (e.key === 'ArrowLeft') {
          currentIndex = (currentIndex - 1 + images.length) % images.length;
          $('.realisations-lightbox__image').attr('src', images[currentIndex]);

        } else if (e.key === 'ArrowRight') {

          currentIndex = (currentIndex + 1) % images.length;
          $('.realisations-lightbox__image').attr('src', images[currentIndex]);
        }
      }
    });




    $('.section-inspirations__card').on('click', function () {

      $('.section-inspirations__pop').addClass('active')
      var imageUrl = $(this).data('pop');
      var imageAlt = $(this).data('alt');
      var imageTitle = $(this).data('title');
      var title_h5 = $(this).find('.section-inspirations__card-content__subtitle')[0]['innerText']
      var title_h4 = $(this).find('.section-inspirations__card-content__title')[0]['innerText']
      var paragraph = $(this).find('p').length > 0 ? $(this).find('p')[0].innerText : '';

      $('.section-inspirations__pop-img img').attr('src', imageUrl)
      $('.section-inspirations__pop-img img').attr('alt', imageAlt)
      $('.section-inspirations__pop-img img').attr('title', imageTitle)
      $('.section-inspirations__pop-img h2').text(title_h5)
      $('.section-inspirations__pop-img h3').text(title_h4)
      if (paragraph) {
        $('.section-inspirations__pop-img p').text(paragraph)
      }
    })

    $('.section-inspirations__pop-close svg').on('click', function () {
      $('.section-inspirations__pop').removeClass('active')
    })


    $('.row-submenu').on('mouseleave', function (event) {

      const $relatedTarget = $(event.relatedTarget);
      $('.container-test').removeClass('active')
      if (!$relatedTarget.closest('.sub-menu__inner').length) {
        $(this).removeClass('active');
      }
    })

    var departmentSelect = $('[name="departementList"]');
    var installateurSelect = $('[name="installateurs"]');


    departmentSelect.on('change', function () {
      var selectedOption = departmentSelect.val();

      // Make an AJAX request
      $.ajax({
        type: 'POST',
        url: seize_data.ajaxUrl,
        data: {
          action: 'custom_search_installateurs',
          selected_option: selectedOption
        },
        success: function (response) {
          // Update the second Select field with the response
          installateurSelect.html(response);
        }
      });
    });



    let searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has('state')) {
      let param = searchParams.get('state')
      $('select[name="departementList"]')
        .find('option[value="' + param + '"]')
        .prop('selected', true)
        .trigger('change') //trigger a change instead of click
        .trigger('click'); //trigger a change instead of click
    }
    if (searchParams.has('city')) {
      setTimeout(() => {
        let param = searchParams.get('city')

        $('select[name="installateurs"]')
          .find('option[value="' + param + '"]')
          .prop('selected', true)
          .trigger('change') //trigger a change instead of click
          .trigger('click'); //trigger a change instead of click
      }, 4000);


    }
    if (searchParams.has('project')) {
      setTimeout(() => {
        let param = searchParams.get('project').replace(/-/g, "_");

        $('input[name="products[]"][value="' + param + '"]')[0].click()
      }, 1500);
    }




    // GENERIC FORM / ALWAYS
    document.addEventListener('wpcf7mailsent', function (event) {

      if (event.detail.contactFormId == '638') {
        window.dataLayer.push({
          "event": "contact-form-success"
        });
      }
      if (event.detail.contactFormId == '6') {
        var checkboxChecked = [];

        $('input[name="products[]"]:checked').each(function () {
          checkboxChecked.push($(this).val());
        });
        var departement = $("select[name='departementList']").val();
        window.dataLayer.push({
          "event": "sav-form-success",
          "nom_produit": checkboxChecked,
          "departement": departement
        });
      }

      if (event.detail.contactFormId == '325') {
        var checkboxChecked = [];

        $('input[name="products[]"]:checked').each(function () {
          checkboxChecked.push($(this).val());
        });
        var departement = $("select[name='departementList']").val();
        window.dataLayer.push({
          "event": "devis-form-success",
          "nom_produit": checkboxChecked,
        });
      }

    })


    // FILE DOWNLOAD /produits/aquarius-solaire-10/
    $('.product-presentation__description-button .btn-stroke').on('click', function () {
      window.dataLayer.push({
        "event": "file-download",
        "file_name": $(this).attr('data-title')
      });
    })

    let language = document.getElementsByTagName('html')[0].getAttribute('lang')
    let pageType = document.getElementsByTagName('body')[0].className.split(" ")[0];

    const getDeviceType = () => {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    };
    let env_channel = getDeviceType();

    // window.dataLayer.push({
    //   "event": "datalayer - loaded",
    //   "pageType": pageType,
    //   "language ": language,
    //   "env_channel ": env_channel,
    //   "page_cat ": pageType
    // });

    $('#list-regions__inner-btn').on('click', function () {
      $(this).siblings('.list-regions__inner').toggleClass('active')
      $(this).hide();
    })


    // $('.cmplz-btn').on('click', function(){
    //   $('#cmplz-cookiebanner-container').addClass('inactive')
    // })



    document.addEventListener('cmplz_fire_categories', function (event) {

      var categories = event.detail.categories;

      $.ajax({
        type: 'POST',
        url: seize_data.ajaxUrl,
        data: {
          action: 'log_user_consent',
          consent: categories,

        },
        success: function (response) {
          // Update the second Select field with the response

        }
      });


    });




  });
})(jQuery);
